import type { QuantitySelectorVariant } from 'components/common/QuantitySelector/QuantitySelector.types';

export const MIN_COUNT = 0;

type CountArgs = {
  count: number;
  isIncrement: boolean;
  maxCount: number;
  minCount?: number;
};

export const getCount = ({ count, maxCount, isIncrement, minCount = MIN_COUNT }: CountArgs) => {
  const finalCount = isIncrement ? getIncrement({ count, maxCount }) : getDecrement(count, minCount);
  return finalCount;
};

const getIncrement = ({ count, maxCount }: { count: number; maxCount: number }) => {
  const incrementedCount = count + 1;

  if (incrementedCount <= maxCount) {
    return incrementedCount;
  }

  return count;
};

const getDecrement = (count: number, minCount: number) => {
  const decrementedCount = count - 1;

  if (decrementedCount >= minCount) {
    return decrementedCount;
  }

  return count;
};

export const getIsDecrementDisabled = ({
  count,
  variant,
  minCount = MIN_COUNT
}: {
  count: number;
  variant: QuantitySelectorVariant;
  minCount?: number;
}): boolean | undefined => {
  if (count <= minCount || getIsActionsDisabled({ variant })) {
    return true;
  }

  return undefined;
};

export const getIsIncrementDisabled = ({
  count,
  maxCount,
  variant
}: {
  count: number;
  maxCount: number;
  variant: QuantitySelectorVariant;
}): boolean | undefined => {
  if (count >= maxCount || getIsActionsDisabled({ variant })) {
    return true;
  }

  return undefined;
};

export const getIsActionsDisabled = ({ variant }: { variant: QuantitySelectorVariant }): boolean | undefined => {
  if (variant === 'disabled') {
    return true;
  }

  return undefined;
};
